import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllContacts(_obj, params) {
    const res = await axios.get('api/contacts/', { params });
    return res.data;
  },
  async getContact(_obj, id) {
    const res = await axios.get(`api/contacts/${id}/`);
    return res.data;
  },
  async createContact(_obj, data) {
    return axios.post('api/contacts/', data);
  },
  async updateContact(_obj, { id, data }) {
    return axios.patch(`api/contacts/${id}/`, data);
  },
  async deleteContact(_obj, id) {
    return axios.delete(`api/contacts/${id}/`);
  },
  async getContactNotes(_obj, id) {
    const res = await axios.get(`api/contacts/${id}/notes/`);
    return res.data;
  },
  async createContactNote(_obj, { id, data }) {
    return axios.post(`api/contacts/${id}/create-note/`, data);
  },
  async getContactActivity(_obj, id) {
    const res = await axios.get(`api/contacts/${id}/activity/`);
    return res.data;
  },
  async importContacts(_obj, data) {
    return axios.post('api/contacts/import/', data);
  },
  async csvPreview(_obj, formData) {
    const res = await axios.post('api/contacts/csv-preview/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
  async csvImport(_obj, formData) {
    const res = await axios.post('api/contacts/csv-import/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data;
  },
  async exportContacts(_obj, params) {
    const res = await axios.get('api/contacts/export/', {
      params,
      responseType: 'blob',
    });
    return res;
  },
  async bulkDeleteContacts(_obj, ids) {
    return axios.post('api/contacts/bulk-delete/', { ids });
  },
  async bulkTagContacts(_obj, data) {
    return axios.post('api/contacts/bulk-tag/', data);
  },
  async bulkStageContacts(_obj, data) {
    return axios.post('api/contacts/bulk-stage/', data);
  },
  async getAllTransitionPrograms(_obj, params) {
    const res = await axios.get('api/contacts/all-programs-from-transition/', { params });
    return res.data;
  },
  async getSchoolOfferedPrograms(_obj, params) {
    const res = await axios.get('api/contacts/school-offered-programs/', { params });
    return res.data;
  },
};

export const contact = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
